import qs from 'qs';
import { fetchPOST, fetchDELETE, fetchGET, fetchPATCH } from 'api/fetchHelper';

const PATH = '/_api/v1/employees';

const Employees = {
  post: ({ body, include } = {}) => (
    fetchPOST(`${PATH}/auth/google_token?${qs.stringify({ include }, { encodeValuesOnly: true })}`, body)
  ),

  getProfile: ({ include } = {}) => (
    fetchGET(`${PATH}/profile?${qs.stringify({ include }, { encodeValuesOnly: true })}`)
  ),

  getAll: ({ page, filter, include, fields }) => (
    fetchGET(`${PATH}?${qs.stringify({ page, filter, include, fields }, { encodeValuesOnly: true })}`)
  ),

  signOut: () => (fetchDELETE(`${PATH}/signout`)),

  create: ({ body }) => (fetchPOST(PATH, body)),

  patch: ({ employeeId, body, include } = {}) => {
    if (!employeeId) throw new Error('employeeId is not defined');
    return fetchPATCH(`${PATH}/${employeeId}?${qs.stringify({ include }, { encodeValuesOnly: true })}`, body);
  },

  changeRoles: ({ body, include } = {}) => (
    fetchPOST(`${PATH}/change_roles?${qs.stringify({ include }, { encodeValuesOnly: true })}`, body)
  ),
};

export default Employees;
